import moment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import PhoneHeader from "../../Components/Common/PhoneHeader";
import Companies from "../../Components/Home/Company";
import Bills from "../../Components/Payment/Bills";
import { setChartData } from "../../Redux/Actions";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { getBills } from "../../Screens/Payment/Payment";
import { urls } from "../../Utils/url";
export const getBillHistory = (
  billId,
  token,
  setHistoryBill,
  history,
  setLoading,
  billName
) => {
  setLoading(true);
  document.getElementById("LoadingChart") &&
    window.scrollTo({
      top: document.getElementById("LoadingChart").offsetTop,
      behavior: "smooth",
    });
  ApiCall(
    "get",
    `${urls.GetBillHistory}${billId}`,
    null,
    "GethistoryBills",
    token,
    function (e) {
      const getDate = (bill) => {
        var date;
        if (bill.bill_company_id === 1) {
          date = bill.info.CurrentDate;
        } else if (bill.bill_company_id === 2) {
          date = bill.info.CurrentReadingDate;
        } else if (bill.bill_company_id === 3) {
          date = bill.info.CurrentReadingDate;
        } else if (bill.bill_company_id === 4) {
          date = moment(bill.updated_at).format("jYYYY / jM / jD");
        } else if (bill.bill_company_id === 5) {
          date = moment(bill.updated_at).format("jYYYY / jM / jD");
        }
        return date;
      };
      const pushData = {
        billId: billName,
        chartData: e.data
          .filter((i) => i.end_of_period === 1)
          .map((i) => {
            return { amount: i.amount, date: getDate(i) };
          }),
        companyId: e.data[0].bill_company_id,
      };
      setHistoryBill(pushData);
      setLoading(false);
      history.push("/chart");
    },
    function (error) {
      setLoading(false);
      console.log(error);
    }
  );
};

function UsageManagment({ token, isLogin, setChartData }) {
  const [companyId, setCompanyId] = useState(0);
  const [bills, setBills] = useState([]);
  const [billId, setBillId] = useState();
  const [historyBill, setHistoryBill] = useState("");
  const [billName, setBillName] = useState("");
  const [moduleID, setModuleID] = useState("");
  const [loading, setLoading] = useState(false);
  const [billsLoading, setBillsLoading] = useState(true);
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (!isLogin) {
      history.push("/login");
    }
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (billId && isLogin) {
      getBillHistory(
        billId,
        token,
        setChartData,
        history,
        setLoading,
        billName
      );
    }
  }, [billId, token]);

  useEffect(() => {
    setBillId("");
    setHistoryBill("");
    companyId !== 0 &&
      document.getElementById("ChooseBillId") &&
      window.scrollTo({
        top: document.getElementById("ChooseBillId").offsetTop,
        behavior: "smooth",
      });
  }, [companyId]);
  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) getBills(setBills, token, setBillsLoading);
    return () => (isSubscribed = false);
  }, [token]);
  useEffect(() => {
    setBillId("");
  }, [companyId]);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
  }, []);
  const filteredBills =
    bills && bills.filter((i) => i.bill_company_id === companyId);
  return (
    <div className="Container useageManagment">
      <div
        className="mobileContainer"
        style={{ paddingTop: window.innerHeight * 0.1 }}
      >
        <PhoneHeader text={"انتخاب قبض"} usage />

        <img
          className="userManageImage"
          id="userManageImage"
          src={require("../../assets/images/Usage.jpeg")}
          alt=""
        />
        <h3>برای مشاهده جزئیات مصرف نوع قبض را مشخص کنید</h3>
        <Companies onClick={setCompanyId} selectedId={companyId} />
        {!loading && companyId != 0 && !billsLoading && (
          <>
            <h3 style={{ color: "#ec4d11" }} id="ChooseBillId">
              {filteredBills.length > 0
                ? "لطفا شناسه مورد نظر را انتخاب نمایید"
                : "تا کنون قبضی پرداخت نکرده اید"}
            </h3>
            <Bills
              usage={true}
              bills={filteredBills}
              billsLoading={false}
              onClick={setBillId}
              onClickName={setBillName}
              setModuleID={setModuleID}
            />
          </>
        )}
        {loading && (
          <div
            id="LoadingChart"
            style={{
              marginBottom: window.innerHeight * 0.1,
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <img
              id="loading"
              className="LoadingImage"
              src={require("../../assets/images/Loading.png")}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    isLogin: state.auth.isLogin,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setChartData: (data) => dispatch(setChartData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsageManagment);
